import React, { type FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {} from "mailup-web-components";
import { openHelp } from "Helpers/openHelp";
import { notifyParent } from "mailup-react-helpers";
import Groups from "./Groups";
import AdvancedSettings from "./AdvancedSettings";
import { initStep4Callback } from "Pages/ImportWizard/recoil/callbacks";
import { useRecoilCallback } from "recoil";
import { gainsightTrack } from "mailup-react-helpers";

const Settings: FC = () => {
  const intl = useIntl();

  const initStep4 = useRecoilCallback(initStep4Callback);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    gainsightTrack("mup_importWizard_visitFourthStep", {});

    initStep4();
  }, []);

  return (
    <>
      <Groups />
      <AdvancedSettings />
    </>
  );
};
export default Settings;
